// @flow

import type { ProductError, ProductId } from '@gandi/cart';

import { ErrorRow } from './Rows';
import { useRemoveProductHandler } from './modules';

type Props = {
  /** productId is used to be able to remove the product */
  productId: ProductId,
  /** each error description will be shown */
  errors?: Array<ProductError>,
};

export default function ProductErrorItem({
  productId,
  errors,
}: Props): React.MixedElement | null {
  const removeProduct = useRemoveProductHandler(productId);

  if (!errors || errors.length === 0) {
    return null;
  }

  return <ErrorRow handleRemoveAction={removeProduct} errors={errors} />;
}
